import { render, staticRenderFns } from "./SodEodWorkloadCalendar.vue?vue&type=template&id=5d520785&scoped=true"
import script from "./SodEodWorkloadCalendar.vue?vue&type=script&lang=js"
export * from "./SodEodWorkloadCalendar.vue?vue&type=script&lang=js"
import style0 from "./SodEodWorkloadCalendar.vue?vue&type=style&index=0&id=5d520785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d520785",
  null
  
)

export default component.exports